module.exports = __webpack_public_path__ + "img/9.407634b2.jpg";